<script lang="ts" setup>
import { Button, Icon } from '@brighterly/lib-lumee-ui'

import { useLessonRoomStore } from '@stores/lesson-room'

import amplitudeConfig from '@config/amplitude.json'

import { trackClassroomEvent } from '@tools/amplitude/classroom'

import posterImage from '@assets/images/classroom/bg-permissions.png'

import { AppModal } from '@UI/Modals/AppModal'

defineOptions({
  name: 'LessonRoomPermissionsBlocked',
})

const lessonRoomStore = useLessonRoomStore()
const { isDesktop } = useDevice()

const close = (): void => {
  trackClassroomEvent(amplitudeConfig.events.clickClosePopupPermissions, { type: 'blocked_permissions' })
  lessonRoomStore.setPermissionsBlocked(false)
}

const openGuides = (): void => {
  lessonRoomStore.setGuideOpen(true)
  lessonRoomStore.setPermissionsBlocked(false)
}

onMounted(() => {
  trackClassroomEvent(amplitudeConfig.events.popupViewPermissions, { type: 'blocked_permissions' })
})
</script>

<template>
  <AppModal @close="close">
    <template #topSlot>
      <div class="lesson-room-permissions__hero">
        <img
          class="lesson-room-permissions__poster"
          :src="posterImage"
          alt=""
        >
      </div>
    </template>
    <template #contentSlot>
      <div class="lesson-room-permissions">
        <h5 class="lesson-room-permissions__title btly-text-title-l">
          Lesson is blocked from using your camera or microphone
        </h5>

        <p
          v-if="isDesktop"
          class="lesson-room-permissions__text btly-text-body-l"
        >
          Click the
          <span class="lesson-room-permissions__text-icon">
            <Icon
              name="video-slash"
              size="md"
              color="inherit"
            />
          </span>
          and
          <span class="lesson-room-permissions__text-icon">
            <Icon
              name="microphone-slash"
              size="md"
              color="inherit"
            />
          </span>
          icons in the address bar, choose “Always allow…”, then reload the page.
        </p>
        <p
          v-else
          class="lesson-room-permissions__text btly-text-body-l"
        >
          Open your browser settings for this site, allow Camera and Microphone access, then reload the page.
        </p>
      </div>
    </template>
    <template #bottomSlot>
      <Button
        text="Open device guides"
        fill
        @click="openGuides"
      />
    </template>
  </AppModal>
</template>

<style scoped lang="scss" src="@scss/components/Blocks/LessonRoom/LessonRoomPermissionsBlocked.scss" />
